export default "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCQAAAAvJ4AGACDSthE6YzN2U4dDAoKi6Z4TCCSJTrpc/xNnYN22DAA="